import { BarChart3, Infinity, MessageSquare, SlidersHorizontal } from 'lucide-react';
import i18n from '../../i18n';

const p = (key, opts) => i18n.t(`modules.shared.aiAgent.agentModes.${key}`, opts);

export const DEFAULT_AGENT_MODE = 'agent';

export const AGENT_MODES = [
  {
    id: 'agent',
    label: p('agent.label'),
    description: p('agent.description'),
    icon: Infinity,
    placeholder: p('agent.placeholder'),
  },
  {
    id: 'plan',
    label: p('plan.label'),
    description: p('plan.description'),
    icon: SlidersHorizontal,
    placeholder: p('plan.placeholder'),
  },
  {
    id: 'ask',
    label: p('ask.label'),
    description: p('ask.description'),
    icon: MessageSquare,
    placeholder: p('ask.placeholder'),
  },
  {
    id: 'analyse',
    label: p('analyse.label'),
    description: p('analyse.description'),
    icon: BarChart3,
    placeholder: p('analyse.placeholder'),
  },
];

export function getAgentMode(modeId) {
  return AGENT_MODES.find((m) => m.id === modeId) || AGENT_MODES[0];
}

/** Composer placeholder: mode-specific; module placeholder wins only in Agent mode. */
export function resolveAgentComposerPlaceholder(agentMode, modulePlaceholder, fallback) {
  const mode = getAgentMode(agentMode || DEFAULT_AGENT_MODE);
  if (mode.id === 'agent' && modulePlaceholder) return modulePlaceholder;
  if (mode.placeholder) return mode.placeholder;
  return modulePlaceholder || fallback || AGENT_MODES[0].placeholder;
}

export function isReadOnlyAgentMode(modeId) {
  return modeId === 'ask' || modeId === 'analyse' || modeId === 'plan';
}

export const AGENT_MODE_STORAGE_KEY = 'qawaem-agent-mode';
